/** Title-case amenity labels (preserves acronyms like BBQ / A/C). */
export function toTitleCase(text: string): string {
  return text.replace(/(^|[\s\-/‑])(\S)/g, (_, sep: string, char: string) => sep + char.toUpperCase());
}

const SELECT_UNITS_RE = /\(\s*select units\s*\)/i;
const WALK_IN_CLOSETS_RE = /walk[\s-]?in\s+closets?/i;
const TRAILING_ASTERISK_RE = /\s*\*+\s*$/;

/** True when an amenity should show the select-homes asterisk / disclaimer. */
export function amenityHasSelectMarker(title: string | null | undefined): boolean {
  const raw = title || '';
  return TRAILING_ASTERISK_RE.test(raw) || SELECT_UNITS_RE.test(raw) || WALK_IN_CLOSETS_RE.test(raw);
}

/** Title-case amenity titles; mark select-unit amenities with a trailing '*'. */
export function formatAmenityTitle(title: string | null | undefined): string {
  let text = toTitleCase(title || '');
  const needsAsterisk = amenityHasSelectMarker(text);

  // Normalize legacy "(select units)" / trailing '*' into a single trailing '*'.
  text = text.replace(SELECT_UNITS_RE, '').replace(TRAILING_ASTERISK_RE, '').replace(/\s+$/, '');

  if (needsAsterisk) {
    return `${text}*`;
  }
  return text;
}
